/* ─────────────── PITSTOP CLIENT JS ─────────────── */
(function(){
  'use strict';

  /* ─────────── PLZ CHECK ─────────── */
  // Allowed Lohmar + Umgebung
  const ALLOWED_PLZ = [
    '53797', // Lohmar
    '53842', // Troisdorf
    '53757', // Sankt Augustin
    '53773', // Hennef
    '53783', // Eitorf
    '53819', // Neunkirchen-Seelscheid
    '53639', // Königswinter
    '51491', // Overath
    '51519', // Odenthal
    '51570'  // Windeck
  ];

  function attachPlzCheck(){
    document.querySelectorAll('.plz-form').forEach(form=>{
      form.addEventListener('submit', e=>{
        e.preventDefault();
        const inp = form.querySelector('input');
        const val = (inp.value||'').trim();
        let msg = form.querySelector('.plz-msg');
        if(!msg){
          msg = document.createElement('div');
          msg.className = 'plz-msg';
          msg.style.cssText = 'margin-top:14px;padding:10px 14px;border-radius:10px;font-family:"JetBrains Mono";font-size:12px;letter-spacing:.04em;text-transform:uppercase;';
          form.parentElement.appendChild(msg);
        }
        if(!/^\d{5}$/.test(val)){
          msg.style.background='#FFE0DA';msg.style.color='#A30400';
          msg.textContent='⚠ PLZ muss 5 Ziffern haben';
          return;
        }
        if(ALLOWED_PLZ.includes(val)){
          msg.style.background='#DCF5E5';msg.style.color='#0E7C3A';
          msg.innerHTML='✓ Top, wir liefern an '+val+' — ca. 20 Min.';
          localStorage.setItem('pitstop_plz', val);
          setTimeout(()=>{ window.location.href='/collections/all'; }, 800);
        } else {
          msg.style.background='#FFE0DA';msg.style.color='#A30400';
          msg.innerHTML='✗ '+val+' liegt nicht in unserer Lieferzone. Wir liefern aktuell nur in Lohmar &amp; direkter Umgebung.';
        }
      });
    });
  }

  /* ─────────── ADD TO CART ─────────── */
  function attachAddToCart(){
    document.querySelectorAll('.p-add[data-variant-id]').forEach(btn=>{
      btn.addEventListener('click', async e=>{
        e.preventDefault();
        e.stopPropagation();
        const id = btn.dataset.variantId;
        if(!id) return;
        btn.style.transform='scale(.9)';
        btn.disabled = true;
        try{
          const res = await fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({items:[{id, quantity:1}]})
          });
          const data = await res.json();
          if(res.ok){
            btn.textContent='✓';
            btn.style.background='var(--green)';
            await refreshCart();
            setTimeout(()=>{
              btn.textContent='+';
              btn.style.background='';
              btn.style.transform='';
              btn.disabled=false;
            }, 1000);
          } else {
            btn.textContent='!';
            console.warn('cart/add failed', data);
            setTimeout(()=>{btn.textContent='+';btn.disabled=false;btn.style.transform='';}, 1000);
          }
        }catch(err){
          console.error(err);
          btn.textContent='!';
          setTimeout(()=>{btn.textContent='+';btn.disabled=false;btn.style.transform='';}, 1000);
        }
      });
    });
  }

  /* ─────────── REFRESH CART (live update) ─────────── */
  async function refreshCart(){
    try{
      const res = await fetch('/cart.js');
      const cart = await res.json();
      // Update sticky bar
      document.querySelectorAll('.checkout .ck-count').forEach(el=>el.textContent=cart.item_count);
      document.querySelectorAll('.checkout .ck-total').forEach(el=>el.textContent=formatMoney(cart.total_price));
      // Update header
      document.querySelectorAll('.cart-btn em').forEach(el=>el.textContent=cart.item_count);
      // Show/hide checkout bar based on items
      const bar = document.querySelector('.checkout');
      if(bar){
        if(cart.item_count > 0){
          bar.style.display='grid';
          bar.style.transform='translateY(0)';
        } else {
          bar.style.transform='translateY(140%)';
        }
      }
    }catch(err){
      console.warn('refreshCart failed', err);
    }
  }

  function formatMoney(cents){
    const num = (cents/100).toFixed(2).replace('.', ',');
    return num + ' €';
  }

  /* ─────────── AGE GATE (Tabak / Vape) ─────────── */
  const RESTRICTED_PATHS = ['/collections/tabak','/collections/vape','/collections/elfbar','/collections/tabakzubehor'];
  const RESTRICTED_KEYWORDS = ['tabak','vape','elfbar','filter','blättchen','blattchen','smoking','gizeh','ocb','zig zag','papers'];
  const AGE_KEY = 'pitstop_age_ok';

  function isRestrictedHref(href){
    if(!href) return false;
    const h = href.toLowerCase();
    if(RESTRICTED_PATHS.some(p=>h.includes(p))) return true;
    if(/\/products\//.test(h) && RESTRICTED_KEYWORDS.some(k=>h.includes(k))) return true;
    return false;
  }

  function buildAgeModal(){
    if(document.getElementById('pitstop-age-modal')) return;
    const overlay = document.createElement('div');
    overlay.className = 'age-overlay';
    overlay.id = 'pitstop-age-modal';
    overlay.innerHTML = '\
      <div class="age-modal" role="dialog" aria-modal="true">\
        <div class="age-icon">🔞</div>\
        <h3>Bist du 16 oder älter?</h3>\
        <p>Tabak und E-Zigaretten dürfen nur an Personen ab 16 Jahren verkauft werden. Bei Lieferung wird der Ausweis kontrolliert.</p>\
        <div class="age-actions">\
          <button class="age-btn age-btn-no" data-age="no">Nein</button>\
          <button class="age-btn age-btn-yes" data-age="yes">Ja, ich bin 16+</button>\
        </div>\
        <small>Eingabe wird auf diesem Gerät gespeichert</small>\
      </div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', e=>{
      if(e.target === overlay) return; // click outside doesn't close — must answer
    });
    overlay.querySelector('[data-age="yes"]').addEventListener('click', ()=>{
      try{ localStorage.setItem(AGE_KEY,'1'); }catch(e){}
      const target = overlay.dataset.target;
      overlay.classList.remove('show');
      if(target) window.location.href = target;
    });
    overlay.querySelector('[data-age="no"]').addEventListener('click', ()=>{
      overlay.classList.remove('show');
      window.location.href = '/';
    });
  }

  function showAgeGate(href){
    buildAgeModal();
    const overlay = document.getElementById('pitstop-age-modal');
    overlay.dataset.target = href;
    overlay.classList.add('show');
  }

  function attachAgeGate(){
    let allowed = false;
    try{ allowed = localStorage.getItem(AGE_KEY) === '1'; }catch(e){}
    document.addEventListener('click', e=>{
      if(allowed) return;
      const a = e.target.closest('a');
      if(!a || !a.href) return;
      if(!isRestrictedHref(a.href)) return;
      e.preventDefault();
      showAgeGate(a.href);
    });
    // Also: if user landed directly on restricted URL without confirmed age
    if(!allowed && isRestrictedHref(location.pathname)){
      showAgeGate(location.pathname);
    }
  }

  /* ─────────── SEARCH AUTOCOMPLETE ─────────── */
  function attachSearch(){
    const wrap = document.querySelector('.ph-search');
    if(!wrap) return;
    const btn = wrap.querySelector('[data-toggle-search]');
    const input = wrap.querySelector('[data-search-input]');
    const results = wrap.querySelector('[data-search-results]');
    if(!btn || !input || !results) return;

    btn.addEventListener('click', e=>{
      e.preventDefault();
      e.stopPropagation();
      wrap.classList.toggle('open');
      if(wrap.classList.contains('open')) setTimeout(()=>input.focus(), 50);
    });

    document.addEventListener('click', e=>{
      if(!wrap.contains(e.target)) wrap.classList.remove('open');
    });

    let timer = null;
    input.addEventListener('input', ()=>{
      const q = input.value.trim();
      clearTimeout(timer);
      if(q.length < 2){ results.innerHTML = ''; return; }
      timer = setTimeout(()=>fetchSuggest(q, results), 220);
    });
  }

  async function fetchSuggest(q, target){
    try{
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      const res = await fetch(url);
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if(!products.length){
        target.innerHTML = '<div class="ph-search-empty">Nichts gefunden für „'+escapeHtml(q)+'"</div>';
        return;
      }
      target.innerHTML = products.map(p=>{
        const img = p.image ? '<img src="'+p.image+'" alt="" />' : '<div class="ph-search-noimg"></div>';
        const price = p.price ? formatMoney(parseFloat(p.price)*100) : '';
        return '<a class="ph-search-item" href="'+p.url+'">'+
          img+
          '<div class="ph-search-meta"><div class="ph-search-title">'+escapeHtml(p.title)+'</div>'+
          '<div class="ph-search-price">'+price+'</div></div></a>';
      }).join('');
    }catch(err){
      target.innerHTML = '<div class="ph-search-empty">Suche derzeit nicht verfügbar</div>';
    }
  }

  function escapeHtml(s){return String(s).replace(/[&<>"']/g, c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));}

  /* ─────────── INIT ─────────── */
  function init(){
    attachPlzCheck();
    attachAddToCart();
    attachAgeGate();
    attachSearch();
    refreshCart();

    // Restore saved PLZ in form
    const savedPlz = localStorage.getItem('pitstop_plz');
    if(savedPlz){
      document.querySelectorAll('.plz-form input').forEach(i=>{ if(!i.value) i.value = savedPlz; });
    }

    // Hide checkout bar initially if cart empty
    const bar = document.querySelector('.checkout');
    if(bar){
      bar.style.transition = 'transform .35s cubic-bezier(.2,.8,.2,1)';
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
